import { render, staticRenderFns } from "./WolverhamptonCity.vue?vue&type=template&id=6e0c641a&scoped=true&"
import script from "./WolverhamptonCity.vue?vue&type=script&lang=js&"
export * from "./WolverhamptonCity.vue?vue&type=script&lang=js&"
import style0 from "./WolverhamptonCity.vue?vue&type=style&index=0&id=6e0c641a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c641a",
  null
  
)

export default component.exports